import { Button, Grid } from "@mui/material"
import CompMap from "../utils/CompMap"
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { useNavigate } from "react-router-dom"

const AnalysisMap = () => {
  const navigate = useNavigate()

  return (<Grid container spacing={2}>
    <Grid item xs={12} sx={{ textAlign: 'left' }}>
      <Button variant='text' size='small' onClick={() => { navigate(-1) }}>
        <NavigateBeforeIcon /> Back
      </Button>
    </Grid>
    <Grid item xs={12}>
      <CompMap />
    </Grid>
  </Grid>)
}

export default AnalysisMap